import { UIText1 } from '@cian/ui-kit';
import { Close16 } from '@cian/ui-kit/prev';
import * as React from 'react';

import * as styles from './FullscreenGalleryHeader.css';
import { DownloadIcon } from './icons';
import { PrettyDateContainer } from '../../containers/PrettyDateContainer/PrettyDateContainer';

interface IFullscreenGalleryHeaderProps {
  src: string;
  created: number | null;
  handleClose: () => void;
  handleSave: () => void;
}

export const FullscreenGalleryHeader: React.FC<IFullscreenGalleryHeaderProps> = ({
  src,
  created,
  handleClose,
  handleSave,
}) => {
  return (
    <div className={styles['container']} data-testid="FullscreenGalleryHeader">
      {created && (
        <div className={styles['date_block']} data-testid="FullscreenGalleryHeaderDate">
          <UIText1 color="white_100">
            <PrettyDateContainer
              date={created}
              showTime
              containerStyles={{ fontSize: 'inherit', lineHeight: 'inherit', color: 'inherit' }}
            />
          </UIText1>
        </div>
      )}
      <div className={styles['buttons_block']}>
        <a href={src} download onClick={handleSave} data-testid="FullscreenGalleryHeaderSaveButton">
          <DownloadIcon />
        </a>
        <div onClick={handleClose} className={styles['close_button']} data-testid="FullscreenGalleryHeaderCloseButton">
          <Close16 color="white_100" />
        </div>
      </div>
    </div>
  );
};
